import * as f from "standard/f";

const attributeChanged = (attributeName) => (target, propertyKey) => {
  const attributeChangedCallback =
    target.attributeChangedCallback ?? (() => undefined);

  Reflect.defineProperty(target, "attributeChangedCallback", {
    value(name, oldValue, newValue) {
      return f.equals(name, attributeName)
        ? this[propertyKey](newValue, oldValue)
        : Reflect.apply(attributeChangedCallback, this, arguments);
    },
    writable: true,
  });
};

export default attributeChanged;
